// extracted by css-extract-rspack-plugin
export default {"barTooltipRow":"barTooltipRow-oEZPFA","barTooltipLabel":"barTooltipLabel-lRwdzL","barTooltipValue":"barTooltipValue-_IWL1M"};